import React from 'react';
import PropTypes from 'prop-types';

import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';

const ValidatedSelectField = ({
	name,
	label,
	formData,
	errors,
	options,
	handleInputChange,
	handleInputBlur,
	...props
}) => {
	return (
		<TextField
			select
			fullWidth
			size='small'
			name={name}
			label={label}
			value={formData[name]}
			error={!!errors[name]}
			helperText={errors[name] || ''}
			onChange={(e) => handleInputChange(name, e.target.value)}
			onBlur={(e) => handleInputBlur(name, e.target.value)}
			inputProps={{ autoComplete: 'off' }}
			{...props}
		>
			{options.map((option) => {
				return (
					<MenuItem
						key={option.abbreviation || option.value}
						value={option.abbreviation || option.value}
						disabled={option.disabled}
					>
						{option.name || option.label}
					</MenuItem>
				);
			})}
		</TextField>
	);
};

ValidatedSelectField.propTypes = {
	name: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	formData: PropTypes.object.isRequired,
	errors: PropTypes.object.isRequired,
	options: PropTypes.array.isRequired,
	handleInputChange: PropTypes.func.isRequired,
	handleInputBlur: PropTypes.func.isRequired
};

export default ValidatedSelectField;
